import React from "react";
import "../App.css";
import { Button } from "./Button";
import "./HeroSection.css";
import "./pages/Pages.css";

document.addEventListener("DOMContentLoaded", (event) => {
  const image = document.getElementById("toggle-image");

  image.addEventListener("click", () => {
    image.classList.toggle("enlarged");
  });
});

function HeroSection() {
  return (
    <div className="hero-container">
      <h1>&lt;FRANK SCHOTANUS/&gt;</h1>
      <p>Leader - Developer - Innovator</p>
      <div className="hero-btns">
        <Button
          className="btns"
          buttonStyle="btn--outline"
          buttonSize="btn--large"
          Dest="/Aboutme"
        >
          ABOUT ME
        </Button>
        <Button
          className="btns"
          buttonStyle="btn--outline"
          buttonSize="btn--large"
          Dest="/Education"
        >
          EDUCATION
        </Button>
        <Button
          className="btns"
          buttonStyle="btn--outline"
          buttonSize="btn--large"
          Dest="/Projects"
        >
          PROJECTS
        </Button>
        <Button
          className="btns"
          buttonStyle="btn--outline"
          buttonSize="btn--large"
          Dest="/RelevantExperience"
        >
          MY EXPERIENCE
        </Button>
        <Button
          className="btns"
          buttonStyle="btn--outline"
          buttonSize="btn--large"
          Dest="/IrrelevantExperience"
        >
          MY (OTHER)EXPERIENCE
        </Button>
      </div>
      <br />
      <br />
      <br />
      <div className="page-body">
        <p>
          Hi and welcome to my website! I'm Frank Schotanus, a recent graduate
          of Florida State University. I will start my career as a software
          engineer at Raymond James as a part of their Accelerated Development
          Program (ADP) in July 2026. I have experience in research, industry,
          and leadership, including 2 internships in financial technology with
          industry leaders. Explore the different pages here to learn more about
          my interests, goals, and experiences.
        </p>
        <div className="home-image">
          <img src="../images/img-9.jpg" alt="Me" />
        </div>
        <div className="caption">
          <p>
            Selfie of me(left) and former Chicago Mayor Lori Lightfoot(right)
          </p>
        </div>
        <br />
        <br />
      </div>
    </div>
  );
}

export default HeroSection;
